import React from 'react';
import { useSettingsContext } from 'components/SettingsContext';
import { Flex } from 'components/ui';
import { useV2Contracts } from 'hooks';
import { useCallback } from 'react';
import { logEvent } from 'utils/analytics';
import MintPrintButton from './MintPrintButton';
import BurnPrintButton from './BurnPrintButton';
import { Original, PrintData } from '../common';
import { useQueryClient } from 'react-query';

interface PrintButtonsProps {
  original: Original;
  userOwnsPrints: boolean;
  printsData: PrintData;
}

const PrintButtonsV2: React.FC<PrintButtonsProps> = ({ original, userOwnsPrints, printsData }) => {
  const { createPrint, burnPrint, burnIsEnabled, printIsEnabled, loading } = useV2Contracts();
  const { allowedPrintSlippage, allowedBurnSlippage } = useSettingsContext();

  const queryClient = useQueryClient();
  // TODO: what to do owner wrong

  const handlePrint = useCallback(
    async (originalId: string, originalOwner: string) => {
      await createPrint(
        originalId,
        originalOwner,
        allowedPrintSlippage,
        () => {},
        async (values: any) => {
          console.log('successfully created a print:', values);
          // Trigger background refetch of balances
          queryClient.invalidateQueries('balances');
          // Trigger background refetch of originals
          queryClient.invalidateQueries('originals');
        }
      );
      logEvent('mint_print', {
        event_category: 'Contract',
        event_label: 'Mint print from Home Page',
        name: originalId,
      });
    },
    [allowedPrintSlippage, createPrint, queryClient]
  );

  const handleBurn = useCallback(
    async (originalId: string) => {
      await burnPrint(originalId, allowedBurnSlippage, async (values: any) => {
        console.log('successfully burned a print:', values);
        // Trigger background refetch of balances
        queryClient.invalidateQueries('balances');
        // Trigger background refetch of originals
        queryClient.invalidateQueries('originals');
      });

      logEvent('burn_print', {
        event_category: 'Contract',
        event_label: 'Burn print from Home Page',
        name: originalId,
      });
    },
    [allowedBurnSlippage, burnPrint, queryClient]
  );

  return (
    <Flex width="100%" alignCenter justifyCenter>
      {
        <MintPrintButton
          mr={userOwnsPrints && burnIsEnabled ? '1' : '0'}
          width={userOwnsPrints && burnIsEnabled ? '50%' : '100%'}
          onClick={() => handlePrint(original.id, original.owner)}
          price={printsData.nextPrintPrice}
          disabled={!printIsEnabled}
          loading={loading}
        />
      }
      {userOwnsPrints && (
        <BurnPrintButton
          ml="1"
          width="50%"
          onClick={() => handleBurn(original.id)}
          price={printsData.burnPrice}
          fontSize="1"
          disabled={!burnIsEnabled}
          loading={loading}
        />
      )}
    </Flex>
  );
};

export default PrintButtonsV2;
